<template>
  <div class="image-product">
    <el-dialog title="海平面变压" :visible.sync="params.flag"  @closed="$parent.toggleProductView(params.productInfo.code)">
      <div class="main">
        <img src="../assets/images/10数据产品.png"/>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: ['params']
}
</script>
<style lang="less" scoped>
.image-product{
  .main{
    position: absolute;
    left: 1.25rem;
    top: 1.25rem;
    right: 1.25rem;
    bottom: 1.25rem;
    img{
      object-fit: contain;
      width: 100%;
      height: 100%;
    }
  }
  /deep/.el-dialog__wrapper {
    .el-dialog {
      width: 56.69rem;
    }
  }
}
</style>
